import Api from './Api'

export default {
  search (query, page) {
    return Api().post('/kunstner/search.json',
      {q: query},
      {params: { page: page || 1 }}
    )
  },

  searchWithSort (query, page = 1, sort = '_score', direction = 'desc') {
    return Api().post('/kunstner/search.json',
      { q: query },
      {
        params: {
          page: page || 1,
          sort: sort || '_score',
          direction: direction || 'desc'
        }
      }
    )
  },

  view (id) {
    return Api().get('/kunstner/' + id + '.json')
  },

  save (id, data) {
    if (!id) {
      return Api().post('/kunstner.json', data)
    }

    return Api().put('/kunstner/' + id + '.json', data)
  },

  delete (id) {
    if (!id) {
      return false
    }

    return Api().delete('/kunstner/' + id + '.json')
  },

  merge (data) {
    return Api().post('/kunstner/merge.json', data)
  }

}



// WEBPACK FOOTER //
// ./src/services/KunstnerService.js